<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>标签详情</span>
      <el-button type="primary"
                 style="width: 92px"
                 size="medium"
                 @click="back">返回</el-button>
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="padding-left:100px">
          <div>
            <span class="labeltitle">标签名称</span>
            <span class="title">{{ detail.label_name }}</span>
          </div>
          <div style="margin: 12px 0">
            <span class="labeltitle">标签状态</span>
            <span v-if="detail.label_status == 1">正常</span>
            <span v-if="detail.label_status == 0">暂停</span>
          </div>
          <div>
            <span class="labeltitle">标签备注</span>
            <span>{{ detail.label_remark }}</span>
          </div>
          <div style="margin: 12px 0">
            <span class="labeltitle">标签创建方式</span>
            <span v-if="detail.create_type == 1">自定义标签</span>
            <span v-if="detail.create_type == 2">sql计算结果</span>
            <span v-if="detail.create_type == 3">导入创建</span>
          </div>
          <div>
            <span class="labeltitle">标签更新方式</span>
            <span v-if="detail.update_type == 1">手动</span>
            <span v-if="detail.update_type == 2">例行</span>
            <el-button v-if="detail.update_type == 1"
                       style="margin-left: 20px"
                       size="medium"
                       type="primary"
                       @click="manualUpdateLabel"
                       :disabled="
                module_id_array[0] ? !module_id_array.includes('1437') : false
              ">更新</el-button>
            <el-button v-if="detail.update_type == 2 &&detail.label_status == 1 "
                       style="margin-left: 20px"
                       size="medium"
                       type="primary"
                       @click="manualUpdateLabel"
                       :disabled="
                module_id_array[0] ? !module_id_array.includes('1437') : false
              ">更新</el-button>
          </div>
        </div>

        <el-tabs type="border-card"
                 v-model="activeName"
                 @tab-click="handleClick"
                 style="margin-top: 20px">
          <el-tab-pane label="标签信息"
                       name="1">
            <div style="font-size: 15px; margin-bottom: 20px"
                 class="flex_between">
              <span>
                <span>人数：</span>
                <span style="margin: 0 50px 0 5px">{{ info_total }}人</span>
                <span v-if="detail.user_update_time">更新时间：</span>
                <span style="margin-left: 5px">{{
                  detail.user_update_time
                }}</span>
              </span>
              <el-button type="primary"
                         style="width: 100px"
                         @click="userLabelDeatilExport"
                         :disabled="
                  module_id_array[0] ? !module_id_array.includes('1424') : false
                ">导 出</el-button>
            </div>
            <div style="border: solid 1px #c9cbd6">
              <el-table ref="multipleTable"
                        :data="info_list"
                        tooltip-effect="dark"
                        style="width: 100%; min-width: 1000px"
                        :header-cell-style="{ background: '#F5F5F5' }">
                <el-table-column prop="user_id"
                                 label="用户ID">
                </el-table-column>
                <el-table-column label="注册时间"
                                 prop="reg_time">
                </el-table-column>
                <el-table-column prop="nick_name"
                                 label="用户昵称"></el-table-column>
                <el-table-column prop="phone"
                                 label="用户手机号"></el-table-column>
              </el-table>
            </div>
            <div style="text-align: center">
              <el-pagination @size-change="InfoSizeChange"
                             @current-change="InfoCurrentChange"
                             :current-page="info_page"
                             :page-sizes="[10, 20, 50, 100]"
                             :page-size="10"
                             layout="total, sizes, prev, pager, next, jumper"
                             :total="info_total"
                             style="margin: 30px 0 20px 0"></el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="标签历史详情"
                       name="2"
                       :disabled="
              module_id_array[0] ? !module_id_array.includes('1425') : false
            ">
            <div style="margin: 10px 0 14px"
                 class="flex_between">
              <span>
                <span>选择日期</span>
                <el-date-picker v-model="date"
                                type="daterange"
                                range-separator="~"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                style="width: 250px; margin-left: 10px"
                                @change="search">
                </el-date-picker>
              </span>
              <el-button type="primary"
                         style="width: 100px"
                         @click="userHistoryLabelListExport"
                         :disabled="
                  module_id_array[0] ? !module_id_array.includes('1426') : false
                ">导 出</el-button>
            </div>
            <div style="border: solid 1px #c9cbd6">
              <el-table ref="multipleTable"
                        :data="history_list"
                        tooltip-effect="dark"
                        style="width: 100%; min-width: 1000px"
                        :header-cell-style="{ background: '#F5F5F5' }"
                        align="center">
                <el-table-column prop="history_time"
                                 label="更新日期">
                </el-table-column>
                <el-table-column label="标签覆盖人数"
                                 prop="user_count">
                </el-table-column>
              </el-table>
            </div>
            <div style="text-align: center">
              <el-pagination @size-change="historySizeChange"
                             @current-change="historyCurrentChange"
                             :current-page="history_page"
                             :page-sizes="[10, 20, 50, 100]"
                             :page-size="10"
                             layout="total, sizes, prev, pager, next, jumper"
                             :total="history_total"
                             style="margin: 30px 0 20px 0"></el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';

export default {
  data() {
    return {
      label_id: this.$route.query.label_id,
      info_page: 1,
      info_size: 10,
      info_total: 0,
      info_list: [],
      activeName: '1',
      detail: {},
      info_list: [],
      history_list: [],
      history_page: 1,
      history_size: 10,
      history_total: 0,
      date: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取详情
    getDetail() {
      let data = {
        page: this.info_page,
        pageNumber: this.info_size,
        label_id: this.label_id
      };
      this.axios.post('platform/Patient/userLabelDeatil', data).then((res) => {
        if (res.code == 0) {
          this.info_list = res.data.list.map((item) => {
            item.reg_time = dayjs
              .unix(item.reg_time)
              .format('YYYY-MM-DD HH:mm');
            return item;
          });
          this.detail = res.data.info;
          this.detail.user_update_time = this.detail.user_update_time
            ? dayjs
                .unix(this.detail.user_update_time)
                .format('YYYY-MM-DD HH:mm:ss')
            : '';
          this.info_total = res.data.total;
        }
      });
    },
    //获取历史详情
    getHistoryList() {
      let data = {
        page: this.history_page,
        pageNumber: this.history_size,
        label_id: this.label_id
      };
      if (this.date && this.date.length > 0) {
        data.history_time_start = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.history_time_end = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      this.axios
        .post('platform/Patient/userHistoryLabelList', data)
        .then((res) => {
          if (res.code == 0) {
            this.history_list = res.data.list.map((item) => {
              item.history_time = dayjs
                .unix(item.history_time)
                .format('YYYY-MM-DD HH:mm:ss');
              return item;
            });
            this.history_total = res.data.total;
          }
        });
    },
    handleClick(tab) {
      this.info_page = 1;
      this.history_page = 1;
      if (tab.name == '1') {
        this.getDetail();
      }
      if (tab.name == '2') {
        this.getHistoryList();
      }
    },
    //每页数据的条数
    InfoSizeChange(size) {
      this.info_size = size;
      this.getDetail();
    },
    //当前第几页
    InfoCurrentChange(page) {
      this.info_page = page;
      this.getDetail();
    },
    //每页数据的条数
    historySizeChange(size) {
      this.history_size = size;
      this.getDetail();
    },
    //当前第几页
    historyCurrentChange(page) {
      this.history_page = page;
      this.getDetail();
    },
    //搜索
    search() {
      this.history_page = 1;
      this.getHistoryList();
    },
    //标签详情导出
    userLabelDeatilExport() {
      let label_id = this.label_id;
      this.axios
        .post('platform/Patient/userLabelDeatilExport', { label_id })
        .then((res) => {
          if (res.code == 0) {
            let host =
              document.location.protocol +
              '//' +
              window.location.host +
              res.data.url;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    //医生标签历史详情导出
    userHistoryLabelListExport() {
      let data = {
        label_id: this.label_id
      };
      if (this.date && this.date.length) {
        data.history_time_start = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.history_time_end = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      this.axios
        .post('platform/Patient/userHistoryLabelListExport', data)
        .then((res) => {
          if (res.code == 0) {
            let host =
              document.location.protocol +
              '//' +
              window.location.host +
              res.data.url;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    //更新
    manualUpdateLabel() {
      let label_id = this.label_id;
      this.$confirm('确定手动更新该标签？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/Patient/manualUpdateLabel', { label_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('操作成功!');
                this.getDetail();
                this.getHistoryList();
              }
            });
        })
        .catch();
    },
    back() {
      history.back();
    }
  },
  created() {
    this.getDetail();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.title {
  font-weight: 700;
  font-size: 16px;
}
.labeltitle {
  display: inline-block;
  width: 120px;
  text-align: right;
  margin-right: 10px;
  color: #666;
}
</style>
